import Logger from '../logger';

const genesysButtonHandler = (e) => {
    window.OPLWCParent.genesysButtonHandler(e);
};

const closerButtonHandler = () => {
    window.WC.Closer.open({
        contactProcessType: 'Support'
    });
};

const attachButtonEvents = (elements) => {
    elements.forEach((element) => {
        const buttons = document.querySelectorAll(element.selector);
        buttons.forEach((button) => {
            if (!button.dataset.userevent) {
                Logger.log(`attaching to user button: ${button.innerText} via ${element.selector}`);
                button.dataset.userevent = element.eventName;
                button.dataset.preloaderType = element.preloaderType ? element.preloaderType : null;
                button.dataset.selector = element.selector;
                button.dataset.attributesToSend = element.attributesToSend;

                if (element.handler && element.handler === 'Closer') {
                    button.addEventListener('click', closerButtonHandler, false);
                } else {
                    button.addEventListener('click', genesysButtonHandler, false);
                }
            }
        }, this);
    }, this);
};

const attachButtonsHandler = (config) => {
    if (!config.onDemand) {
        return;
    }

    let attachInterval = null;

    // try to attach to buttons. We need to wait for a while for full page init by require.js or other async stuff (eg. modals)
    const retries = config.onDemand.retries || [1, 500, 1000, 2000, 3500, 6000, 10000];
    retries.forEach((timeout) => {
        Logger.log(`try attachButtons - ${timeout}`);
        setTimeout(() => attachButtonEvents(config.onDemand.elements), timeout);
    });

    // after above retries try to attach every 5 seconds... forever.
    if (attachInterval) {
        clearInterval(attachInterval);
        attachInterval = null;
    }
    setTimeout(() => {
        Logger.log('try attachButtons forever');
        attachInterval = setInterval(() => attachButtonEvents(config.onDemand.elements), 5000);
    }, 15000);
};

export { attachButtonsHandler };
